import { Language } from '@core/shared';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultResources, resources } from './resources';

export const getTranslations = (lng: Language) => {
    const patch = { ...(resources[lng]?.translation ?? {}) } as { [key: string]: string };

    // Remove all keys that are the same in the default translation
    Object.keys(defaultResources[lng]?.translation ?? {}).forEach((key) => {
        if (defaultResources[lng].translation[key] === patch[key]) {
            delete patch[key];
        }
    });

    return {
        original: defaultResources[lng].translation,
        patch: patch
    };
};

export const switchLanguage = (lng: Language) => i18n.changeLanguage(lng);
export const loadPatch = (lng: Language) => i18n.reloadResources(lng);

export const usei18n = (lng: Language) => {
    if (i18n.isInitialized || i18n.isInitializing) {
        return i18n;
    }

    i18n.use(initReactI18next).init({
        resources,
        lng,
        fallbackLng: 'en',
        debug: false,
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        },
        react: {
            useSuspense: false
        }
    });

    return i18n;
};
